import { createEvent, createStore } from 'effector'

export const markAsLoggedOutOF = createEvent(
  'mark it as logged out depending on responses',
)
export const $isLoggedInOF = createStore(true).on(
  markAsLoggedOutOF,
  () => false,
)
